import { InlineIcon } from "@iconify/react";

interface ConnectionStatusIndicatorProps {
  connectionStatus: string;
}

export function ConnectionStatusIndicator({ connectionStatus }: ConnectionStatusIndicatorProps) {
  const getTitle = () => {
    switch (connectionStatus) {
      case "open":
        return "Connected";
      case "connecting":
        return "Connecting...";
      default:
        return "Disconnected";
    }
  };

  const getColorClass = () => {
    switch (connectionStatus) {
      case "open":
        return "text-green-500";
      case "connecting":
        return "text-yellow-500";
      default:
        return "text-red-500";
    }
  };

  return (
    <span title={getTitle()} className="ConnectionStatusIndicator">
      <InlineIcon icon="mdi:circle" className={`text-sm ${getColorClass()}`} />
    </span>
  );
}
